import * as React from 'react';

/**
 * MUI icon for Chevron down
 */
const ChevronDownIcon = ({
  width = '16',
  height = '16',
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15 5.32252L13.355 3.67752L8 9.02085L2.645 3.67752L0.999999 5.32252L8 12.3225L15 5.32252Z"
      fill="#1E2229"
    />
  </svg>
);

export default ChevronDownIcon;
